<template>
  <div class="Drag-component" :draggable="draggable" @dragstart="dragstart" @dragend="dragend">
    <slot />
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import EventBus from '@/controller/EventBus';
import './index.scss';

const emit = defineEmits(['dragstart', 'dragend']);
const props = defineProps({
  dataTransferKey: {
    type: String,
    default: 'dataTransferKey',
  },
  draggable: {
    type: Boolean,
    default: true,
  },
  dragRef: Object,
  dataSource: Object,
  dragImage: Object,
});

function dragstart(event) {
  // 设置此次拖拽不是拖拽上传
  EventBus.setCanDragUpload.execEvent('cannotDragUpload', true);
  emit('dragstart', event);
  const data = JSON.stringify(props.dataSource);
  event.dataTransfer.setData(props.dataTransferKey, data);

  if (props.dragImage?.src) {
    event.dataTransfer.setDragImage(
      props.dragImage.src,
      props.dragImage.w / 2,
      props.dragImage.h / 2
    );
  }
  // e.DataTransfer.setDragImage(e.target.children[0],0,0)
}
function dragend(event) {
  event.dataTransfer.clearData();
  emit('dragend', event);
}
</script>
